import React, {Component, Fragment} from 'react';
import moment from 'moment';
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import "./CalendarView.scss"
import {
    useDashboardCaseBlockHeaderColor,
    useDashboardEventList,
    useDashboardUnitKey
} from "../../containers/Layouts/CustomHooks";
import SubIcon from "../../images/sub_icon.svg";
import BigCalendar from "react-big-calendar";
import ModalComponent from "../Modal";
import {getSmallCalendarData, getVacationDaysRequest} from "../../containers/Layouts/Admin/dashboard/actions";
import IconAngleDown from "react-icons/lib/fa/angle-down";
import IconOpenNew from "react-icons/lib/md/open-in-new";

import {
    useDashboardEventStyle,
} from "../../containers/Layouts/CustomHooks";
import {globals} from "../../../../common/constants";
import dates from "react-big-calendar/lib/utils/dates";

const initialState = {
    defaultDate: new Date(),
    isMinimized:true,
    showSmallCalendar: true,
    isMaximized:false,
    currentDentist: {},
    type: '',
    message: '',
    showDentistList: true,
    searchedValue: '',
    dentists: [],
    searchedDentist: {},
    width: 300,
    height: 400,
    x: window.innerWidth - 320,
    y: window.innerHeight - 420,
    eventList: [],
    startOfCalendarView: moment().startOf('month').startOf('week').format('YYYY-MM-DD'),
    endOfCalendarView: moment().endOf('month').endOf('week').format('YYYY-MM-DD'),
}
const calendarStyle = {
    width: 60,
    height: 60,
    position: 'fixed',
    zIndex: 990,
    bottom: 10,
    right: 100,
    borderRadius: 30,
    backgroundColor: '#54D043',
    cursor: 'pointer'
}

class CalendarView extends Component {
    constructor(props) {
        super(props);
        this.state = initialState
    }

    componentDidMount() {
        if(this.props.isCalendarClosed){
            this.setState({isMinimized:true,showSmallCalendar:false});
        }
        this.props.getVacationDays()
        this.props.getData(this.state.startOfCalendarView,this.state.endOfCalendarView);
        this.setState({
            eventList: useDashboardEventList(this.props.eventsListSmallCalendar)
        });

        if(!this.props.isChatClosed){
            this.props.setChatClosed(true);
        }
        this.props.changeCalendarState(false);

        const startOfCalendarView =moment().startOf('month').startOf('week').format('YYYY-MM-DD');
        const endOfCalendarView = moment().endOf('month').endOf('week').format('YYYY-MM-DD');
        this.props.getData(startOfCalendarView, endOfCalendarView);
        this.setState({
            showSmallCalendar:true,
            isMinimized:false,
            startOfCalendarView,
            endOfCalendarView,
            eventList: useDashboardEventList(this.props.eventsListSmallCalendar)
        });
        if (this.state.showSmallCalendar) {
            this.minimizeCalendar();
            this.props.changeCalendarState();
            return;
        }

    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isCalendarClosed && this.props.isCalendarClosed) {
            this.minimizeCalendar();
        }

        if(prevProps.eventsListSmallCalendar !== this.props.eventsListSmallCalendar) {
            this.setState({
                eventList: useDashboardEventList(this.props.eventsListSmallCalendar)
            })
        }
    }

    minimizeCalendar = ()  => {
        clearInterval(this.interval);
        this.setState({
            isMinimized:true,
            showSmallCalendar:false,
            eventList: []
        });
    }

    maximizeCalendar = () => {
        const startOfCalendarView = moment().startOf('month').startOf('week').format('YYYY-MM-DD');
        const endOfCalendarView = moment().endOf('month').endOf('week').format('YYYY-MM-DD');
        this.props.getData(startOfCalendarView, endOfCalendarView);
        this.setState({
            showSmallCalendar:false,
            isMaximized:true
        });
    }

    handleCloseBigCalendar = () => {
        clearInterval(this.interval);
        this.setState({isMinimized:true,isMaximized:false, eventList: []});
    }

    onDateRangeChange = (date, view, action) => {
        clearInterval(this.interval);
        const startOfCalendarView = moment(dates.firstVisibleDay(date)).format('YYYY-MM-DD');
        const endOfCalendarView = moment(dates.lastVisibleDay(date)).format('YYYY-MM-DD');
        this.setState({
            startOfCalendarView,
            endOfCalendarView
        });
        this.props.getData(startOfCalendarView, endOfCalendarView);
        this.interval = setInterval(() => {
            this.props.getData(startOfCalendarView, endOfCalendarView)
        }, 7000);
        this.setState({
            eventList: useDashboardEventList(this.props.eventsListSmallCalendar)
        })
    };

    getTitle(bookedMisc, bookedZirc,  misc, zirconia) {
        return `Misc: ${bookedMisc} / ${misc}  Zirc: ${bookedZirc} / ${zirconia}`
    }

    renderEventHeader(props) {
        var numberOfUnits;
        const unitsKey = useDashboardUnitKey(props.date, this.props.numberOfUnits);
        const dayKey = moment(props.date).format('YYYY-MM-DD');
        let misc = globals.NUMBER_OF_UNITS_MISC,
            zirconia = globals.NUMBER_OF_UNITS_ZIRCONIA,
            bookedMisc = 0,
            bookedZirc = 0;
        if (unitsKey !== undefined) {
            misc = this.props.numberOfUnits[unitsKey].units;
            zirconia = this.props.numberOfUnits[unitsKey].units_for_zirconia;
            bookedMisc = this.props.numberOfUnits[unitsKey].booked;
            bookedZirc = this.props.numberOfUnits[unitsKey].bookedZirconia;
        } else if (this.specialDays && this.specialDays[dayKey] !== undefined) {
            misc = this.specialDays[dayKey].units;
            zirconia = this.specialDays[dayKey].units_for_zirconia || 0;
        }
        const statusOfDay = (unitsKey !== undefined) ? this.props.numberOfUnits[unitsKey].status : 'scheduled';
        const className = useDashboardCaseBlockHeaderColor(props.date, this.state.dateAfter10Days, misc, zirconia, statusOfDay,this.props.vacationDays)

        return (
            <div
                title={this.getTitle(bookedMisc, bookedZirc, misc, zirconia)}
                className={"custom-day-header-" + className}
            >
                {props.label}
            </div>

        )
    }

    showCalendarView = () => {
        if (this.state.showSmallCalendar) {
            this.minimizeCalendar();
            this.props.changeCalendarState();
            return;
        }
        if(!this.props.isChatClosed){
            this.props.setChatClosed(true);
        }
        this.props.changeCalendarState(false);

        const startOfCalendarView = moment(dates.firstVisibleDay(this.state.defaultDate)).format('YYYY-MM-DD');
        const endOfCalendarView = moment(dates.lastVisibleDay(this.state.defaultDate)).format('YYYY-MM-DD');
        this.props.getData(startOfCalendarView,endOfCalendarView);
        this.setState({
            startOfCalendarView,
            endOfCalendarView,
            showSmallCalendar:true,
            isMinimized:false,
            eventList: useDashboardEventList(this.props.eventsListSmallCalendar)
        })
    }

    render() {
        return <div id="calendar-widget" style={calendarStyle}>
            <div className="minimized-calendar" onClick={this.showCalendarView}>
                <span className="kr kr-calendar" />
            </div>
            {
                this.state.showSmallCalendar && this.renderSmallCalendar()
            }
            {
                this.state.isMaximized && this.renderMaximizedCalendar()
            }
        </div>
    }

    renderSmallCalendar = () => {
        return (
            <div className="small-calendar">
                <div className="open-actions">
                    <div className='maximize-calendar-btn' onClick={this.maximizeCalendar}>
                        <IconOpenNew />
                    </div>
                    <div className='minimize-calendar-btn' onClick={this.minimizeCalendar}>
                        <IconAngleDown />
                    </div>
                </div>
                <BigCalendar
                    onNavigate={this.onDateRangeChange}
                    className="bigcalendar"
                    events={this.state.eventList}
                    style={{ height: 500 }}
                    startAccessor='startDate'
                    endAccessor="endDate"
                    views={{ month: true, week: true, day: true }}
                    eventPropGetter={useDashboardEventStyle}
                    defaultView='month'
                    longPressThreshold={250}
                    timeslots={8}
                    defaultDate={this.state.defaultDate}
                    popup={true}
                    components={{
                        month: {
                            dateHeader: (props) => this.renderEventHeader(props),
                            event: (props) => {
                                return (
                                    <div className="rbc-row-segment">
                                        <div>
                                            <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'other' ? 'other-case' : props.event.type === 'ceramic' ? 'ceramic-case' : 'zirconia-case'}`}>
                                                <div className="type-block">
                                                    <div className="rbc-event-content text-left"
                                                         title={props.event.title}>
                                                        {props.event.title}
                                                    </div>
                                                    <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                    <ReactTooltip html={true} place="top" type="light" effect="float" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        },
                        week: {
                            header: (props) => this.renderEventHeader(props),
                            event: (props) => {
                                return (
                                    <div className="rbc-row-segment">
                                        <div>
                                            <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'other' ? 'other-case' : props.event.type === 'ceramic' ? 'ceramic-case' : 'zirconia-case'}`}>
                                                <div className="type-block">
                                                    <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                    <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                    <ReactTooltip place="top" type="light" effect="float" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        },
                        day: {
                            header: (props) => this.renderEventHeader(props),
                            event: (props) => {
                                return (
                                    <div className="rbc-row-segment day">
                                        <div>
                                            <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'other' ? 'other-case' : props.event.type === 'ceramic' ? 'ceramic-case' : 'zirconia-case'}`}>
                                                <div className="type-block">
                                                    <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                    <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                    <ReactTooltip place="top" type="light" effect="float" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        }
                    }}
                />
            </div>
        )
    }

    renderMaximizedCalendar = () => {
        return (
            <div>
                <ModalComponent
                    modalHeaderStyle="modalHeaderDefault"
                    headerTitle={'Calendar View'}
                    dialogClassName="calendar-modal"
                    modalBody={
                        <BigCalendar
                            onNavigate={this.onDateRangeChange}
                            className="bigcalendar"
                            events={this.state.eventList}
                            style={{ height: 500 }}
                            startAccessor='startDate'
                            defaultDate={this.state.defaultDate}
                            endAccessor="endDate"
                            longPressThreshold={250}
                            views={{ month: true, week: true, day: true }}
                            eventPropGetter={useDashboardEventStyle}
                            defaultView='month'
                            timeslots={8}
                            popup={true}
                            components={{
                                month: {
                                    dateHeader: (props) => this.renderEventHeader(props),
                                    event: (props) => {
                                        return (
                                            <div className="rbc-row-segment">
                                                <div>
                                                    <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'other' ? 'other-case' : props.event.type === 'ceramic' ? 'ceramic-case' : 'zirconia-case'}`}>
                                                        <div className="type-block">
                                                            <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                            <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                            <ReactTooltip html={true} place="top" type="light" effect="float" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                },
                                week: {
                                    header: (props) => this.renderEventHeader(props),
                                    event: (props) => {
                                        return (
                                            <div className="rbc-row-segment">
                                                <div>
                                                    <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'other' ? 'other-case' : props.event.type === 'ceramic' ? 'ceramic-case' : 'zirconia-case'}`}>
                                                        <div className="type-block">
                                                            <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                            <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                            <ReactTooltip place="top" type="light" effect="float" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                },
                                day: {
                                    header: (props) => this.renderEventHeader(props),
                                    event: (props) => {
                                        return (
                                            <div className="rbc-row-segment day">
                                                <div>
                                                    <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'other' ? 'other-case' : props.event.type === 'ceramic' ? 'ceramic-case' : 'zirconia-case'}`}>
                                                        <div className="type-block">
                                                            <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                            <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                            <ReactTooltip place="top" type="light" effect="float" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                }
                            }}
                        />
                    }
                    show={this.state.isMaximized}
                    handleClose={this.handleCloseBigCalendar}
                    cancelButtonName='Close'
                    buttonDisabled={true}
                    infoModal={true}
                    buttonFunction={() => this.handleSaveBooking()}
                />
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        vacationDays: state.adminDashboard.vacationDays,
        eventsListSmallCalendar: state.adminDashboard.smallCalendarData.events,
        numberOfUnits: state.adminDashboard.smallCalendarData.numberOfUnits,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getVacationDays: (startOfCalendarView) => dispatch(getVacationDaysRequest(startOfCalendarView)),
        getData: (startOfCalendarView, endOfCalendarView) => dispatch(getSmallCalendarData(startOfCalendarView, endOfCalendarView)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CalendarView)


// WEBPACK FOOTER //
// ./src/components/CalendarView/CalendarView.js